module.exports = __webpack_public_path__ + "img/client_rice.8dedacd5.svg";